// ── Avatar selection view ─────────────────────────────────────────────────────
// For logged-in users: shows ONLY the avatar images + a "Select your avatar"
// heading. Picking one transitions to the avatar preview view.

import { MUTED, TEXT } from '../tokens';
import { AVATAR_EMPTY_SVG } from '../icons';
import { esc } from '../helpers';
import type { ViewContext } from '../modal-types';

export function renderAvatars(ctx: ViewContext): void {
  const { state, content, set, selectFile } = ctx;
  const hasAvatars = state.avatars.length > 0;

  content.innerHTML = `
    ${ctx.headerHTML()}
    <div class="ts-mbody ts-flow-layout">
      <div class="ts-flow-panel">
        ${state.error ? `<div class="ts-error">${esc(state.error)}</div>` : ''}
        <div class="ts-avatar-hdr">
          <h3>Select your avatar</h3>
          <button class="ts-avatar-upload-btn" id="ts-upload-new" type="button">+ Upload New</button>
        </div>
        ${hasAvatars ? `
          <div class="ts-avatar-grid">
            ${state.avatars.map(a => `
              <div class="ts-avatar-thumb ${a.id === state.selectedAvatarId ? 'selected' : ''}" data-id="${esc(a.id)}">
                <img src="${esc(a.signedUrl)}" alt="Avatar" loading="lazy" />
                <div class="ts-avatar-check">✓</div>
              </div>
            `).join('')}
          </div>
        ` : `
          <div style="text-align:center;padding:32px 0 16px;color:${MUTED};font-size:14px">
            <div style="color:${MUTED};margin-bottom:10px;display:flex;justify-content:center">${AVATAR_EMPTY_SVG}</div>
            <p style="margin:0 0 4px;font-weight:600;color:${TEXT}">No avatars yet</p>
            <p style="margin:0">Upload a photo above to start trying on clothes</p>
          </div>
        `}
        <input type="file" id="ts-avatar-file-inp" accept="image/png,image/jpeg,image/webp" style="display:none" />
      </div>
    </div>
  `;

  // "+ Upload New" opens the OS file picker straight away (no detour through the
  // upload view). The chosen photo flows through the shared selectFile handler —
  // it sets the preview and starts the silent avatar upload, then shows the
  // upload-preview screen so the user can hit "Try this …".
  content.querySelector('#ts-upload-new')?.addEventListener('click', () => {
    content.querySelector<HTMLInputElement>('#ts-avatar-file-inp')?.click();
  });

  content.querySelector('#ts-avatar-file-inp')?.addEventListener('change', () => {
    const inp = content.querySelector<HTMLInputElement>('#ts-avatar-file-inp');
    const f = inp?.files?.[0];
    if (f) {
      selectFile(f);
      set({ phase: 'upload', error: null });
    }
    if (inp) inp.value = '';
  });

  content.querySelectorAll<HTMLDivElement>('.ts-avatar-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const id = thumb.dataset.id ?? null;
      if (!id) return;
      set({ selectedAvatarId: id, error: null, phase: 'avatar-preview' });
    });
  });
}
